function trackMixpanelEvent(eventName, metadata) {
  if (typeof window === 'undefined') return;
  try {
    if (window.mixpanel?.track) {
      // Attach replay id if available
      const replayProps = window.mixpanel.get_session_recording_properties?.() || {};
      window.mixpanel.track(eventName, {
        ...metadata,
        ...replayProps
      });
    }
  } catch (e) {
    console.error('Error tracking Mixpanel event:', e);
  }
}

export { trackMixpanelEvent };
